import { useState, useCallback } from 'react';
import { useApolloClient } from '@apollo/client';

import getZipcode from 'commons/getZipcode';
import { GET_CART } from 'mocks/queries';
import { EMPTY_CART } from 'mocks/mutations';
import { logError } from 'commons/logger';

const useEmptyCart = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const client = useApolloClient();

  const emptyCart = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      // Run the emptyCart mutation
      await client.mutate({
        mutation: EMPTY_CART,
      });

      // Manually refetch the GET_CART query to ensure it's completed
      await client.query({
        query: GET_CART,
        variables: { zipCode: getZipcode() },
        fetchPolicy: 'network-only', // force network refetch
      });
    } catch (err) {
      logError(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [client]);

  return { emptyCart, loading, error };
};

export default useEmptyCart;
